export default __webpack_public_path__ + "static/media/icon2.7ba50c07.svg";